<template>
	<v-input
		v-model="content"
		:rules="rules"
	>
		<ui-box :class="elementClass" :borderColor="outlineColor" :borderWidth="outlineWidth">
			<tiptap-vuetify
				v-model="content"
				:card-props="{ flat: true }"
				:class="elementClass"
				:extensions="localExtensions"
				@blur="(e) => { markErrors = true; hasFocus = false }"
				@focus="(e) => hasFocus = true"
				@input="(e) => { markErrors = true }"
			>
				<template v-if="label" #toolbar-before>
					<label class="v-label v-label--active theme--light d-block mb-2 mt-n1">{{ label }}</label>
				</template>
			</tiptap-vuetify>
		</ui-box>
	</v-input>
</template>

<script>
import {
	Bold,
	BulletList,
	History,
	Italic,
	Image,
	Link,
	ListItem,
	TiptapVuetify,
	Underline
} from 'tiptap-vuetify';

export default {
	name: 'TiptapVuetifyInput',
	components: {
		TiptapVuetify
	},
	props: {
		className: {
			type: String,
			default: 'w-100'
		},
		extensions: {
			type: [Array, null],
			default: () => null
		},
		label: String,
		rules: {
			type: Array,
			default: () => []
		},
		value: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			defaultExtensions: [
				Bold,
				Underline,
				Italic,
				Link,
				Image,
				ListItem,
				BulletList,
				History
			],
			hasFocus: false,
			markErrors: false
		}
	},
	computed: {
		content: {
			get() {
				return this.value;
			},
			set(html) {
				let formatted = html.replace(/<p><\/p>/g, '<p><br></p>') // hack to preserve breaks when they want to "add space"
				formatted = formatted.replace(/href="([^"]*)"/g, function (match, p1) {
					return 'href="' + p1.replace(/&amp;/g, '&') + '"';
				});
				this.$emit("input", formatted);
			}
		},
		elementClass() {
			const classes = [];

			if (this.className)
				classes.push(this.className);

			if (!this.value.length || this.value === '<p><br></p>')
				classes.push('is-empty');

			if (this.hasFocus) 
				classes.push('has-focus');

			if (this.errorMessages.length && this.markErrors)
				classes.push('has-errors');

			return classes.join(' ');
		},
		errorMessages() {
			const messages = [];

			for (const rule of this.rules) {
				const result = rule(this.content);
				if (result !== true) {
					messages.push(result);
				}
			}

			return messages;
		},
		localExtensions() {
			return this.extensions || this.defaultExtensions;
		},
		outlineColor() {
			if (this.errorMessages.length && this.markErrors) {
				return 'var(--v-error-base)';
			} else if (this.hasFocus) {
				return 'var(--v-primary-base)';
			}

			return 'rgba(0, 0, 0, 0.38)';
		},
		outlineWidth() {
			return (this.errorMessages.length && this.markErrors) || this.hasFocus
				? '2px'
				: '1px';
		}
	}
}
</script>
<style lang="scss">
.tiptap-vuetify-image-upload-area {
	h3 {
		visibility: hidden;
		position: relative;
		&::before {
			content: "Click or tap here to upload your image(s)";
			color: #3c3c3c;
			text-align: center;
			visibility: visible;
			position: absolute;
			top: 50%; 
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}
}
</style>
